// extracted by css-extract-rspack-plugin
export default {"serverQueryOpSummary":"src-wab-client-components-sidebar-tabs-ServerQuery-QueryResultPreview-module__serverQueryOpSummary-TenCL7"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"serverQueryOpSummary\":\"src-wab-client-components-sidebar-tabs-ServerQuery-QueryResultPreview-module__serverQueryOpSummary-TenCL7\"}";
        // 1793541995859
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  